import { defineComponent as p, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as A, createElementVNode as n, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, M = { key: 1 }, Z = { key: 2 }, f = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconMusicNoteSimple"
}, S = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const a = r, { bind: d, weight: s } = m(a);
    return (i, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      A(i.$slots, "default"),
      e(s) === "bold" ? (l(), o("g", V, t[0] || (t[0] = [
        n("path", { d: "M211.45,52.51l-80-24A12,12,0,0,0,116,40V140.22A52,52,0,1,0,140,184V56.13l64.55,19.36a12,12,0,1,0,6.9-23ZM88,212a28,28,0,1,1,28-28A28,28,0,0,1,88,212Z" }, null, -1)
      ]))) : e(s) === "duotone" ? (l(), o("g", M, t[1] || (t[1] = [
        n("path", {
          d: "M128,184a40,40,0,1,1-40-40A40,40,0,0,1,128,184Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M210.3,56.34l-80-24A8,8,0,0,0,120,40V148.26A48,48,0,1,0,136,184V50.75l69.7,20.91a8,8,0,1,0,4.6-15.32ZM88,216a32,32,0,1,1,32-32A32,32,0,0,1,88,216Z" }, null, -1)
      ]))) : e(s) === "fill" ? (l(), o("g", Z, t[2] || (t[2] = [
        n("path", { d: "M210.3,56.34l-80-24A8,8,0,0,0,120,40V148.26A48,48,0,1,0,136,184V50.75l69.7,20.91a8,8,0,1,0,4.6-15.32Z" }, null, -1)
      ]))) : e(s) === "light" ? (l(), o("g", f, t[3] || (t[3] = [
        n("path", { d: "M209.72,58.25l-80-24A6,6,0,0,0,122,40V153.05A46,46,0,1,0,134,184V48.06l72.27,21.69a6,6,0,1,0,3.45-11.5ZM88,218a34,34,0,1,1,34-34A34,34,0,0,1,88,218Z" }, null, -1)
      ]))) : e(s) === "regular" ? (l(), o("g", k, t[4] || (t[4] = [
        n("path", { d: "M210.3,56.34l-80-24A8,8,0,0,0,120,40V148.26A48,48,0,1,0,136,184V50.75l69.7,20.91a8,8,0,1,0,4.6-15.32ZM88,216a32,32,0,1,1,32-32A32,32,0,0,1,88,216Z" }, null, -1)
      ]))) : e(s) === "thin" ? (l(), o("g", h, t[5] || (t[5] = [
        n("path", { d: "M209.15,60.17l-80-24A4,4,0,0,0,124,40V158.75A44,44,0,1,0,132,184V45.38l74.85,22.45a4,4,0,0,0,2.3-7.66ZM88,220a36,36,0,1,1,36-36A36,36,0,0,1,88,220Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  S as default
};
